// React
import { ReactElement } from 'react';
// Next
import dynamic from 'next/dynamic';
// Interfaces
import { PiCategoryEnum } from '@utmb/types/enum/PiCategoryEnum';

export interface CategoryIconProps {
    icon: PiCategoryEnum;
}

const Icons = {
    [PiCategoryEnum.PI20K]: dynamic(() => import('./icons/TwentyKIcon')),
    [PiCategoryEnum.PI50K]: dynamic(() => import('./icons/FiftyKIcon')),
    [PiCategoryEnum.PI100K]: dynamic(() => import('./icons/HundredKIcon')),
    [PiCategoryEnum.PI100M]: dynamic(() => import('./icons/HundredMIcon')),
};

export const QualifierIcon = (props: CategoryIconProps): ReactElement => {
    const { icon } = props;

    if (icon in Icons) {
        const Icon = Icons[icon as keyof typeof Icons];
        return <Icon />;
    }
    return <></>;
};
